import { isBarberSessionView } from '../../session';
export var getUserTraits = function (session) {
    if (!session) {
        return {};
    }
    if (isBarberSessionView(session.view)) {
        return {
            first_name: session.view.viewer.firstName,
            last_name: session.view.viewer.lastName,
            email: session.view.viewer.email,
            username: session.user.username,
        };
    }
    return {
        username: session.user.username,
    };
};
